import React from "react";

import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import makeStyles from '@mui/styles/makeStyles';
import { grey } from '@mui/material/colors';

const layoutStyles = makeStyles(theme => ({
  paper: {
    marginBottom: theme.spacing(3)
  },
  header: {
    padding: theme.spacing(1),
    backgroundColor: grey[50]
  },
  headerControls: {
    textAlign: 'right',
    padding: theme.spacing(0.5),
    backgroundColor: grey[50]
  },
  subtitle: {
    fontSize: theme.typography.pxToRem(19),
    fontWeight: 'bold'
  },
  formToolbar: {
    backgroundColor: grey[100],
    padding: theme.spacing(1)
  }
}));

const ArticleBase = props => {
  const { children } = props;
  const classes = layoutStyles(props.theme);
  return <Paper className={classes.paper} elevation={2}>{children}</Paper>;
}

const Article = props => {
  const { children, header } = props;
  const classes = layoutStyles(props.theme);
  return (
    <Paper className={classes.paper} elevation={2}>
      <Grid container spacing={0}>
        <Grid item xs={12} className={classes.header}>
          <Typography variant="h6" component="h2" className={classes.subtitle}>
            {header}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          {children}
        </Grid>
      </Grid>
    </Paper>
  );
};

const ArticleDataTable = props => {
  const { children, header, headerControls } = props;
  const classes = layoutStyles(props.theme);
  return (
    <Paper className={classes.paper} elevation={2}>
      <Grid container spacing={0}>
        <Grid item xs={6} className={classes.header}>
          <Typography variant="h6" component="h2" className={classes.subtitle}>
            {header}
          </Typography>
        </Grid>
        <Grid item xs={6} className={classes.headerControls}>
          {headerControls}
        </Grid>
        <Grid item xs={12}>
          {children}
        </Grid>
      </Grid>
    </Paper>
  );
};

const FormFooter = props => {
  const { children } = props;
  const classes = layoutStyles(props.theme);
  return (
    <Toolbar variant="dense" className={classes.formToolbar} disableGutters>
      {children}
    </Toolbar>
  );
};

export { ArticleBase, ArticleDataTable, Article, FormFooter };
